<router-outlet></router-outlet>

@if (switchInProgress()) {
  <div class="absolute inset-0 bg-surface-0 dark:bg-surface-800 grid place-items-center">
      <bb-loading-spinner [label]="`Loading ${switchInProgress()?.name}...`"/>
  </div>
}

<p-toast/>
